/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

class BlockSelector extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: "unstyled",
		};
	}

	changeValue = newValue => {
		const { onChange, value } = this.props;
		if (newValue !== value) {
			onChange(newValue);
		}
	};

	render() {
		const { onChange, value } = this.props;

		return (
			<div>
				<select
					onChange={event => {
						onChange(event.target.value);
					}}
					value={value}
				>
					<option value="unstyled">Plain Text</option>
					<option value="header-one">H1</option>
					<option value="header-two">H2</option>
					<option value="header-three">H3</option>
					<option value="header-four">H4</option>
					<option value="header-five">H5</option>
					<option value="header-six">H6</option>
					<option value="small">Small</option>
					<option value="mini">Mini</option>
				</select>
			</div>
		);
	}
}

BlockSelector.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.string,
};

export default BlockSelector;
